import axios from 'axios'
import router from '../../router'
import { ui } from '@/ui/services'

const fetch = ({ methods, url, data }) => new Promise((resolve, reject) => {
  axios[methods](url, data)
    .then(({ data: response }) => {
      const { code, message, data: result } = response
      if (code === 200) {
        resolve(result)
      } else {
        ui.loading.hide()
        if (code === 403 || code === 400) {
          ui.toast.text(message)
        } else if ((message || '').includes('Your request was made with invalid credentials')) {
          localStorage.removeItem('access_token')
          router.push('/')
        } else {
          ui.toast.text('系统错误，请重试')
        }
        reject(new Error(message || '请求失败'))
      }
    })
    .catch(reject)
})

export default fetch
